// thunks.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createAsyncThunk } from '@reduxjs/toolkit'
import CMCClient from '../../data/cmcClient'
import { buildAuthenticatedUser } from '../../common/authenticatedUser'
import { logoutUser } from '../globalActions'

export const loginUser = createAsyncThunk(
  'user/loginUser',
  async (args: {
    userId: string
    password: string
    twoFactorToken: string
    dataCenter: string
  }): Promise<{
    SessionGuid: string
    Eula: boolean
    UserUniqueId: number
    UserId: string
    RealName: string
    dataCenter: string
  }> => {
    const {
      userId, password, twoFactorToken, dataCenter
    } = args

    const { data } = await CMCClient.login(userId, password, twoFactorToken, dataCenter)

    return {
      ...data,
      dataCenter
    }
  }
)

export const validateSession = createAsyncThunk(
  'user/validateSession',
  async (args: {
    sessionId: string
    dataCenter: string
    userId: string
  }): Promise<boolean> => {
    const { sessionId, dataCenter, userId } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)

    return CMCClient.isSessionValid(authUser)
  }
)

export const logoutCmcUser = createAsyncThunk(
  'user/logoutCmcUser',
  async (args: {
    sessionId: string
    dataCenter: string
    userId: string
  }, { dispatch }): Promise<void> => {
    const { sessionId, dataCenter, userId } = args
    const authUser = buildAuthenticatedUser(sessionId, dataCenter, userId)
    try {
      await CMCClient.logout(authUser)
    } finally {
      dispatch(logoutUser())
    }
  }
)
